import {z} from 'zod';
import {ApiDefinition} from '../definitions';
import {IntegrationTypeSchema} from '../../integrations';
import {ObjectIdSchema} from '../../zod';

export const DisconnectIntegration = {
  path: 'integration/disconnect',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: IntegrationTypeSchema,
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DeleteIntegration = {
  path: 'integration/delete',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: IntegrationTypeSchema,
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const GetSalesforceErrors = {
  path: 'integration/salesforceErrors',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    customerId: ObjectIdSchema.optional(),
    jobIds: z.string().array(),
  }),
  responseDataSchema: z.string(),
} satisfies ApiDefinition;
